import { useEffect, useState } from "react";
import ChakraUIRenderer from "chakra-ui-markdown-renderer";
import {
  Box,
  Button,
  Code,
  FormControl,
  FormLabel,
  HStack,
  Input,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { CopyIcon } from "@chakra-ui/icons";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";

import NavMenu from "../../components/Menu";

export default function AddressParsingAPI() {
  const [postContent, setPostContent] = useState("");
  const [address, setAddress] = useState("");
  const [apiResponse, setApiResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const handleCopy = () => {
    apiResponse && navigator.clipboard.writeText(apiResponse);
    toast({
      title: "Success!",
      description: "API response successfully copied to your clipboard",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  // For Address Parsing API testing
  async function handleSubmit() {
    try {
      setIsLoading(true);
      const response = await fetch(`${process.env.REACT_APP_ADDRESS_PARSING}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": String(process.env.REACT_APP_ADDRESS_API_KEY),
        },
        body: JSON.stringify({ address }),
      });

      var data = await response.json();

      if (data.address) {
        toast({
          title: "Success!",
          description: "Address Parsing successfully completed",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else if (data.Error) {
        toast({
          title: "Error!",
          description: "Please check your input",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }

      setApiResponse(JSON.stringify(data, null, 2));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast({
        title: "Error!",
        description: "There was an error fetching data",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }

  // Getting the md document
  useEffect(() => {
    import("../address-parsing-api/address-parsing-api.md").then((res) => {
      fetch(res.default)
        .then((response) => response.text())
        .then((response) => setPostContent(response))
        .catch((err) => console.log(err));
    });
  }, []);

  return (
    <VStack backgroundColor={"#e0e0e0"}>
      <NavMenu />
      <article className="article">
        <div className="container">
          <div className="post-wrapper">
            <ReactMarkdown
              components={ChakraUIRenderer()}
              children={postContent}
              remarkPlugins={[remarkGfm]}
              skipHtml
            />
            <br />
            <div className="api-test">
              <h1>Try out the Address Parsing API:</h1>
              <Box>
                <FormControl isRequired m={"5px"}>
                  <HStack>
                    <FormLabel pb={0} mb={0}>
                      Address
                    </FormLabel>
                    <Input
                      type="text"
                      placeholder="Enter address"
                      borderColor={"#bcbcbc"}
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                    <Button
                      isLoading={isLoading}
                      loadingText="Loading"
                      colorScheme="teal"
                      onClick={handleSubmit}
                      isDisabled={!address}
                      variant={"outline"}
                    >
                      Execute
                    </Button>
                  </HStack>
                </FormControl>

                {apiResponse && (
                  <Box position="relative" mt={4}>
                    <Code whiteSpace="pre" width={"100%"}>
                      {apiResponse}
                      <Button
                        colorScheme={"white"}
                        _hover={{ color: "teal.600" }}
                        size="sm"
                        position="absolute"
                        top="0"
                        right="0"
                        mt={"15px"}
                        mr={"10px"}
                        onClick={handleCopy}
                        variant={"outline"}
                        leftIcon={<CopyIcon />}
                      >
                        Copy
                      </Button>
                    </Code>
                  </Box>
                )}
              </Box>
            </div>
          </div>
        </div>
      </article>
    </VStack>
  );
}
